module.exports = __webpack_public_path__ + "assets/pdf.ee8485c0.svg";